const isForceProduction = false

export const isDevelopeMode =
  (location.hostname.includes("localhost") ||
    location.hostname.includes("runflare") ||
    location.hostname.includes("dev-aio") ||
    (location.port.includes("19006") && location.protocol.includes("http:"))) &&
  !isForceProduction

export default {
  aioUrl: isDevelopeMode
    ? // ? "http://10.83.55.37:8000/aio/v2"
      // "http://192.168.43.94:8000/aio/v2"
      "https://dev-api-ah.runflare.run/aio/v2"
    : "https://api.aminh.ir/aio/v2",
  supportUrl: isDevelopeMode
    ? "http://10.83.55.37:8005/api/v1"
    : "https://ms-support.aminh.ir/api/v1",
  appVersion: 207,
}

export const redirects = [
  {
    from: "/page/sitevideo",
    to: "https://aminh.ir/page/sitevideo",
  },
  {
    from: "/page/logovideo",
    to: "https://aminh.ir/page/logovideo",
  },
]
